import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import CopyrightIcon from '@mui/icons-material/Copyright';
import '../shared.css';

function CategoryIndex() {
  const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
  const history = useHistory();
  const [data, setData]                     = useState([]);
  const [searchQuery, setSearchQuery]       = useState('');
  const [showSearch, setShowSearch]         = useState(false);
  const [deleteItemId, setDeleteItemId]     = useState(null);
  const [confirmOpen, setConfirmOpen]       = useState(false);

  const hasCreate = permissions.includes('Create Master');
  const hasEdit   = permissions.includes('Edit Master');
  const hasDelete = permissions.includes('Delete Master');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    fetchTableData();
  }, [isAuthenticated, companyId, branchId, token, logout]);

  const fetchTableData = () => {
    fetchData('CategoryApi', `/${companyId}`, token)
      .then(res => { if (res.responseCode === '1111') setData(res.response_data); })
      .catch(err => {
        console.error(err);
        if (err.response?.status === 401) { logout(); history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`); }
      });
  };

  const handleDelete = () => {
    deleteData('CategoryApi', `${deleteItemId}`, token)
      .then(() => { fetchTableData(); setDeleteItemId(null); setConfirmOpen(false); })
      .catch(err => console.error(err));
  };

  const handleActivate = (id) => {
    activateData('CategoryApi', `${id}`, token).then(fetchTableData).catch(console.error);
  };

  const filtered = data.filter(item =>
    Object.values(item).some(v => String(v).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <div className="pg-container">
      <div className="pg-header">
        <h5 className="pg-title">Category</h5>
        <div className="pg-header-actions">
          <button className="pg-btn pg-btn-outline" onClick={() => setShowSearch(v => !v)}>
            <SearchIcon /> Search
          </button>
          {showSearch && (
            <input className="pg-input" style={{ width: 180 }} placeholder="Search…"
              value={searchQuery} onChange={e => setSearchQuery(e.target.value)} autoFocus />
          )}
          {hasCreate && (
            <Link to="/CategoryCreate" className="pg-btn pg-btn-primary">
              <AddIcon /> Create New
            </Link>
          )}
        </div>
      </div>

      <div className="pg-table-wrap">
        <table className="pg-table">
          <thead>
            <tr><th>#</th><th>Category</th><th style={{ textAlign: 'right' }}>Actions</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0
              ? <tr><td colSpan={3} style={{ textAlign: 'center', color: '#94a3b8', padding: 16 }}>No records found</td></tr>
              : filtered.map((item, i) => (
                <tr key={item.Id} style={{ opacity: item.IsActive ? 1 : 0.5 }}>
                  <td>{i + 1}</td>
                  <td>{item.Name}</td>
                  <td className="actions-cell">
                    {hasEdit && <Link to={`/categoryEdit/${item.Id}`}><IconButton size="small" color="primary"><EditIcon style={{ fontSize: 17 }} /></IconButton></Link>}
                    {hasDelete && (
                      <IconButton size="small" onClick={() => item.IsActive ? (setDeleteItemId(item.Id), setConfirmOpen(true)) : handleActivate(item.Id)}>
                        {item.IsActive ? <DeleteIcon style={{ fontSize: 17, color: '#dc2626' }} /> : <ActivateIcon style={{ fontSize: 17, color: 'darkolivegreen' }} />}
                      </IconButton>
                    )}
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Delete Record?</DialogTitle>
        <DialogContent><DialogContentText>Are you sure you want to delete this record?</DialogContentText></DialogContent>
        <DialogActions>
          <button className="pg-btn pg-btn-danger" onClick={() => setConfirmOpen(false)}>Cancel</button>
          <button className="pg-btn pg-btn-success" onClick={handleDelete}>Confirm</button>
        </DialogActions>
      </Dialog>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
}

export default CategoryIndex;
